import {c, color, theme, is_mobile} from './modules/settings.js';

(function ($) {
	$(document).ready(function(){
    renderSymbols();
  });

  $(document).ready(function(){
    $('span.symbol-big, .symbol-big > p > span').each(function(){
      $(this).parent().css('text-align', 'center');
      $(this).addClass($(this).text());
      if(!$(this).hasClass('symbol-big')){
        $(this).addClass('symbol-big');
      }
      $(this).text('');
    });
  });


  function renderSymbols(){
    $(' td:not(.head) span.symbol, td:not(.head) .symbol > p > span').each(function(){
      $(this).parent().css('text-align', 'center');
      $(this).addClass($(this).text());
      if(!$(this).hasClass('symbol')){
        $(this).addClass('symbol');
      }
      $(this).text('');
    });

    $('.symbol.t').append('<svg width="78px" height="66px" viewBox="0 0 78 66" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Tabelle_mit_Statusanzeige" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(-936.000000, -619.000000)" id="Group-4" stroke="currentColor" stroke-width="10"><g transform="translate(35.000000, 272.000000)"><polyline id="Line" points="906.919922 388.691406 927.970703 407.833984 973.466797 352.488281"></polyline></g></g></g></svg>');
  }

  $(document).on('noteLoaded', function(){
    renderSymbols();
  });

})(jQuery);
